import type { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../i18n';
import { TextBlock } from './TextBlock';

export const GuestBarLabel: FC<{ children?: ReactNode }> = (props) => (
  <TextBlock {...props}>
    <FormattedMessage {...messages.guestBarLabel} />
  </TextBlock>
);
